import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, DAPPROVER_API, SUPRIVISOR_API } from '../../ApiNames';


export const fetchAct = (get: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: get,
});
export const fetch = (image: any) => ({
    type: 'FETCH_IMG_SUCCESS',
    payload: image,
});




export const fetchData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname = DAPPROVER_API.daprofile_API;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAct(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = DAPPROVER_API.daprofilephoto_API;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(fetch(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};


